import { Service } from '../Service';
import { ModelFactory } from './ModelFactory';
/**
 * API for constructing models.
 */
export class ModelService extends Service {
    constructor(modules, globeService) {
        super(modules);
        Object.defineProperty(this, "factory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dirty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.factory = new ModelFactory(this.renderer, this.meshBatch, this.meshInstance, this.labelManager, globeService, () => this.signalDirty());
        this.dirty = false;
    }
    /**
     * Build a model from a configuration object.
     *
     * @param config
     */
    async create(config) {
        return await this.factory.create(config);
    }
    /**
     * Signal a refresh of the batchable meshes.
     */
    signalDirty() {
        this.dirty = true;
    }
    /**
     * Refresh the batchable meshes if any models have changed.
     *
     * @param deltaTime
     */
    updateFrame(deltaTime) {
        if (this.dirty) {
            this.dirty = false;
            this.meshBatch.refresh();
        }
    }
}
